const items = [
  "عناية تصنع الفرق",
  "طبيعي 100%",
  "بدون عطر",
  "129 درهم فقط",
  "الدفع عند الاستلام",
  "توصيل لجميع المدن المغربية",
  "STOP · CURE · CARE",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-[#2E9E6B]/15 bg-[#0F1E19] py-5"
      data-testid="editorial-marquee"
      dir="ltr"
    >
      <div className="marquee-track flex w-max items-center gap-10" style={{ direction: "ltr" }}>
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap" dir="rtl">
            <span className="font-display text-lg font-bold text-[#FBF9F4]/90">{item}</span>
            <span className="text-[#D4AF37]">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
